module.exports = __webpack_public_path__ + "static/media/checked_box.b691cc12.svg";